import * as React from 'react';
import { useParams } from 'react-router-dom';
import {useEffect, useState} from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Link from "@mui/material/Link";
import VideoSummaryCard from "../videoSummary";
import Grid from "@mui/material/Grid";
import VideoDetailsCard from "../videoDetails";
import Drawer from '@mui/material/Drawer';

import Button from "@mui/material/Button";
import authService from '../api-authorization/AuthorizeService'
import {Update} from "@mui/icons-material";
import SimpleBackdrop from "../backdrop";
import Box from "@mui/material/Box";
import Title from "../Title";
import IssueList from "../issues/issuelist";
import MDEditor, {commands} from "@uiw/react-md-editor";
import {useEditor} from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import moment from "moment/moment";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {Backdrop, Chip, Snackbar, styled} from "@mui/material";
import LoadingButton from '@mui/lab/LoadingButton';
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Gauge from "./gauge";
import {LineChart} from "@mui/x-charts/LineChart";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import MoneyIcon from "@mui/icons-material/Money";
import Alert from "@mui/material/Alert";
import DetailsIcon from "@mui/icons-material/Details";
import ProfileChangesTable from "./ProfileChangesTable";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import CheckIcon from "@mui/icons-material/Check";
import CancelIcon from "@mui/icons-material/Cancel";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import CustomPaginationActionsTable from "../reportEntryUrlTable";
import PropTypes from "prop-types";
//https://codesandbox.io/s/jzbml?file=/src/MyDialog.js:3636-3640

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};
function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function ChannelDetails({channel}) {
    const [value, setValue] = React.useState("");
    const [loading, setLoading] = React.useState(false);
    const [snackOpen, setSnackOpen] = React.useState(false);
    const [noteLoading, setnoteLoading] = React.useState(false);
    
    const updateDetails = (v) => {

    };

    useEffect(() => {
        if(channel.notes){

            setValue(channel.notes.note_text);
        }
        addChartData(channel);
    }, [channel])
    const saveNotes = async () => {

        setnoteLoading(true);
        var req = {
            notes: value
        }
        //const token = await authService.getAccessToken();
        const response = await fetch('/api/channels/details/'+channel.id+'/notes', {
            method: "PUT",
            headers: {/*'X-Authorization': `Bearer ${token}`,*/ 'Content-Type': 'application/json' },
            body: JSON.stringify(req)
        });
        authService.followIfLoginRedirect(response);
        console.log(response);
        setSnackOpen(true);
        setnoteLoading(false);

    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackOpen(false);
    };

    const action = (
        <React.Fragment>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleClose}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </React.Fragment>
    );

    function getPercentageChange(numbers) {
        if (numbers.length < 2) {
            return 0; //throw new Error('Array must contain at least two numbers to calculate percentage change.');
        }

        const newest = numbers[0];
        const oldest = numbers[numbers.length - 1];

        // Calculate the percentage change 
        let percentageChange = ((newest - oldest) / oldest) * 100;
        if (!isFinite(percentageChange)) {
            percentageChange = 1000;
        }
        return round(percentageChange,2);
    }

    const [chartData, setChartData] = useState([]);
    const [xLabels, setxLabels] = useState([]);

    const round = (value, exp) => {
        if (typeof exp === 'undefined' || +exp === 0)
            return Math.round(value);

        value = +value;
        exp  = +exp;

        if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0))
            return NaN;

        // Shift
        value = value.toString().split('e');
        value = Math.round(+(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp)));

        // Shift back
        value = value.toString().split('e');
        return +(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp));
    }
    const handleUrlPreviewClose = () => {
        setOpenUrlPreviewOpen(false);
    };
    const handleScreenshotfailedClose = () => {
        setScreenshotFailedOpen(false);
    }
    const handleUrlPendingClose = () => {
        setUrlPendingOpen(false);
    };

    const handleScreehotFailedClose = () => {
        setOpenUrlPreviewOpen(true);
        setScreenshotFailedOpen(false);
    }
    function getTotalDaysDifference(dates) {
        if (dates.length < 2) {
            throw new Error('Array must contain at least two dates to calculate the difference.');
        }

        // Helper function to convert a date string 'dd-mm-yyyy' to a Date object
        function parseDate(dateStr) {
            const [year, month, day] = dateStr.split('-').map(Number);
            return new Date(year, month - 1, day); // Month is 0-indexed in JavaScript Date
        }

        const newestDate = parseDate(dates[0]);
        const oldestDate = parseDate(dates[dates.length - 1]);

        // Calculate the difference in time
        const timeDifference = newestDate - oldestDate;

        // Convert time difference from milliseconds to days
        const daysDifference = timeDifference / (1000 * 60 * 60 * 24);

        return Math.round(daysDifference); // Rounding to the nearest whole number
    }

    const addChartData = (data) => {
        

        const keysPressure = Object.keys(data.rankings);
        const valuesPressure = Object.values(data.rankings);

        const every10thKeysPressure = [];
        const every10thValuesPressure = [];

        for (let i = 0; i < keysPressure.length; i++) {
            every10thKeysPressure.push(keysPressure[i]);
            every10thValuesPressure.push(round(valuesPressure[i],2));
        }

        //video additions 
        setChartData([{
            data: every10thValuesPressure.reverse(),
            label: "Pressure"
        }]);

        setxLabels(every10thKeysPressure.reverse());
    }

    const StyledDialog = styled(Dialog)(({ theme }) => ({
        zIndex: theme.zIndex.drawer + 1, // Ensure the dialog is above other elements
    }));

    const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
        zIndex: (theme) =>
            Math.max.apply(Math, Object.values(theme.zIndex)) + 1, // Ensure the backdrop is above the dialog
        color: '#fff',
    }));

    
    function loadingUrlBackdrop() {
        return (<StyledBackdrop
            sx={{ color: '#fff' }}
            open={openUrlLoadingBackdrop}
            onClick={handleBackdropClose}
        >
            <CircularProgress color="inherit" />
        </StyledBackdrop>)
    }
    const [openUrlLoadingBackdrop, setOpenUrlLoadingBackdrop] = React.useState(false);
    const [showUrlNotAnalyzedDialog, setShowUrlNotAnalyzedDialog] = React.useState(false);
    const [openUrlPending, setUrlPendingOpen] = React.useState(false);
    const [openUrlPreviewOpen, setOpenUrlPreviewOpen] = React.useState(false);
    const [currentUrlDetails, setCurrentUrlDetails] = React.useState({"brands":[],"aff_urls_dest_page":[],"request":{"Parameters": {"Url": ""}}})
    const [currentUrlLinks, setCurrentUrlLinks] = React.useState([]);
    const [currentScreenshotObjective, setCurrentScreenshotObjective] = React.useState({});
    const [downloadAvailable, setDownloadAvailable] = React.useState(false);
    const [redirects, setRedirects] = React.useState([]);
    const [downloadingScreenshot, setDownloadingScreenshot] = React.useState(false);
    const [currentDownloadId, setCurrentDownloadId] = React.useState(0);
    const [screenshotFailedOpen, setScreenshotFailedOpen] = React.useState(false);
    const slugify = (title) => {
        return title
            .trim()
            .replace(/ +/g, '-')
            .toLowerCase()
            .replace(/[^a-z0-9-]/g, '')
    }
    const handleBackdropClose = () => {
        //do nothing
    };
    function downloadScreenshot(){
        setOpenUrlLoadingBackdrop(true);
        setOpenUrlPreviewOpen(false);
        doDownloadScreenshot(currentDownloadId).then((r)=>{console.log('')})
    } 
 
    const doDownloadScreenshot = async (id) =>{
        console.log('downloading');
        setCurrentDownloadId(id);
        setOpenUrlLoadingBackdrop(true);
        setDownloadingScreenshot(true);
        //const token = await authService.getAccessToken();
        const response = await fetch('/api/channels/'+channel.id +'/details/url/' + id + '/file', {
            method: "GET",
            headers: {
                'Content-Type': 'image/jpeg' // Adjust according to the image type you expect
            }
        });
        setDownloadingScreenshot(false);
        if (response.ok) {
            setOpenUrlLoadingBackdrop(false);
            // Redirect to "/issues/" on success
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = slugify(moment(currentUrlDetails.request.DateGenerated).format("DD-MM-YYYY") +"----"+ currentUrlDetails.request.Parameters.Url) + ".jpg"; // Default file name
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            setOpenUrlPreviewOpen(true);
        } else {
            // Handle error if needed
            setOpenUrlLoadingBackdrop(false);
            setScreenshotFailedOpen(true);
        }
    }
    
    const openPreview = (urlId) => {
        console.log(urlId);
        setCurrentDownloadId(urlId);
        setOpenUrlLoadingBackdrop(true);
        setDownloadAvailable(false);
        setCurrentUrlLinks([]);
        setCurrentScreenshotObjective({});
        setRedirects([]);
        fetch("/api/channels/" + channel.id + "/details/url/" + urlId + "/details", {
            method: "GET"
        })
            .then(async (response) => {
                const contentType = response.headers.get('content-type');
                setOpenUrlLoadingBackdrop(false);

                if (response.status === 204) {
                    setUrlPendingOpen(true);
                } else if (response.status === 202) {
                    setShowUrlNotAnalyzedDialog(true); // Show info dialog
                } else {
                    const data = await response.json();
                    setCurrentUrlDetails(data);
                    setOpenUrlPreviewOpen(true);

                    const screenshotObjective = data.request.Objectives.find(x => x.Type === "screenshot");
                    if (screenshotObjective) {
                        setCurrentScreenshotObjective(screenshotObjective);
                        setDownloadAvailable(true);
                    }

                    const linkObjective = data.request.Objectives.find(x => x.Type === "links");
                    if (linkObjective) {
                        setCurrentUrlLinks(linkObjective.Result.Links);
                    }

                    const redirectObjective = data.request.Objectives.find(x => x.Type === "redirect");
                    if (redirectObjective) {
                        setRedirects(redirectObjective.Result.Urls);
                    }
                }
            })
            .catch(() => {
                setOpenUrlLoadingBackdrop(false);
                console.log('No internet connection found. App is running in offline mode.');
            });
    }

    const [tabUrlIndexvalue, setUrltabIndexValue] = React.useState(0);
    const handleUrlTabIndexChange = (event, newValue) => {
        console.log(newValue);
        setUrltabIndexValue(newValue);
    };

    function CustomUrlTabAffLink() {
        let c = currentUrlDetails.aff_urls_dest_page
        const customLabel = (
            <Stack direction={"row"} spacing={2} alignItems={"center"}>
                <span>Affiliate links on page</span> <Chip label={c.length} />
            </Stack>
        );

        return customLabel;
    }
    function CustomUrlTabAllLink() {
        let c = currentUrlLinks.length;
        const customLabel = (

            <Box direction={"row"} spacing={2} alignItems={"center"}>
                <span>All Links</span>  <Chip label={c} />
            </Box>

        );

        return customLabel;
    }
    function CustomUrlTabRedirect() {
        let c = (currentUrlDetails.aff_urls_in_redirects ?? []).length;
        const customLabel = (

            <Box direction={"row"} spacing={2} alignItems={"center"}>
                <span>Affiliate Links In Redirect</span>  <Chip label={c} />
            </Box>

        );

        return customLabel;
    }
    return (
        <React.Fragment>
            <Title>{channel.channel_name}</Title>
            <Box component="div" sx={{mt: 0, mb: 2}}>
                <Title>Overview</Title>
                <strong>Average video discovery time:</strong> {channel.average_days_between_video} <br/>
                <strong>Total Discovered Videos</strong> {channel.total_discovered_videos} <br/>
                <strong>Subscribers </strong> {channel.subscriber_count} <br/>
                <strong>Verified </strong> {channel.verified ? "yes":"no"} <br/>
            </Box>

            <Title>Channel Description</Title>
            <Box>

                {channel.channel_description}
            </Box>
            <Box component="div" sx={{mt: 3, mb: 2}}>
                <Title>Pressure</Title>
                <Grid container spacing={0}>
                    
                    <Grid item xs={6} direction="row"
                          justifyContent="flex-end"
                          alignItems="center">
                        <Stack direction="column"
                               justifyContent="flex-end"
                               alignItems="center">
                            <Typography sx={{fontWeight:"bold"}}>Current Pressure</Typography>
                            <Typography variant={"h3"}  sx={{mb:2, textAlign:"center"}}>{round(channel.overall_pressure_rating,2)} / 100</Typography>
                            <Gauge needleRotation={(channel.overall_pressure_rating * 1.8)} percentChanged={getPercentageChange(Object.values(channel.rankings))} daysDuration={getTotalDaysDifference(Object.keys(channel.rankings))}/>
                        </Stack>
                    </Grid>
                    <Grid item xs={6}  alignItems={"center"}
        
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between',
                                height: '100%'
                            }}
                        >
                            <LineChart
                                series={chartData}
                                height={200}
                                disableHighlight
                                disableLineItemHighlight
                                xAxis={[{ scaleType: 'point', data: xLabels }]}
                                leftAxis={null}
                                margin={{
                                    left: 30,
                                    right: 10,
                                    top: 30,
                                    bottom: 10,
                                }}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </Box>


            <Title>Urls</Title>
            <Typography>These are the urls found in the current users profile. </Typography>
            <Box>
                {channel.channel_urls.length > 0 ? (
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Last seen</TableCell>
                                    <TableCell>Published Url</TableCell>
                                    <TableCell>Details</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {channel.channel_urls.map((row) => (
                                    <TableRow hover key={row.id}>
                                        <TableCell>{moment(row.date_last_seen).format('MMMM Do YYYY, h:mm:ss a')}</TableCell>
                                        <TableCell>
                                            <a
                                                href={`https://1855proxy.xyz/?${row.url}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {row.url}
                                            </a>
                                        </TableCell>
                                        {/* Uncomment if Details button is needed later */}
                                        <TableCell>
         
                <Button key={row.id} disabled={downloadingScreenshot} onClick={() => openPreview(row.id)}>
                  <DetailsIcon />
                </Button>
              
            </TableCell> 
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                ) : (
                    <Typography variant="body1">This profile has no URLs in it.</Typography>
                )}
            </Box>
            <Title>Profile changes</Title>
            <Typography>These are the most recent profile changes</Typography>
            <Box>
            <ProfileChangesTable profileChanges={channel.profile_changes} />

        </Box>

    <Box component="div" sx={{mt: 3, mb: 2}}>
                <Title>Notes</Title>
                <p>Leave a note, something important. Anything. Everybody in your team can see this, not just you.</p>

                <MDEditor
                    value={value}
                    onChange={setValue}
                    preview="edit"
                    commands={[
                        commands.codeEdit, commands.codePreview,
                        commands.bold, commands.code, commands.quote,
                        commands.title1, commands.title2, commands.title3, commands.title4, commands.title5, commands.title6
                    ]}

                />
                <Box component="div" sx={{mt: 2}}>
                    <LoadingButton loading={noteLoading} onClick={() => {saveNotes();console.log(value)}} variant="contained" sx={{mr: 2}}>
                        Save
                    </LoadingButton>

                    {channel.notes &&
                        <small>Notes last updated by {channel.notes.user.display_name} on {moment(channel.notes.notes_last_updated).format('MMMM Do YYYY, h:mm:ssa')}</small>
                    }
                </Box>
            </Box>


            {channel.issues && channel.issues.length > 0 && (
                <Box component="div" sx={{mt: 3, mb: 2}}>
                    <Title>Issues related to this channel</Title>
                    <IssueList issues={channel.issues .reverse()} showadvanced={true} />
                </Box>
            )}


            <Box component="div" sx={{mt: 3, mb: 2}}>
                <Title>Videos in this channel</Title>
                {channel.videos.map((row) => {
                    return (
                        <VideoSummaryCard channel={channel} parentCallback={updateDetails} key={row.id} video={row} channelId={channel.id}  />
                    );
                })}
            </Box>

            <Snackbar
                open={snackOpen}
                autoHideDuration={10000}
                onClose={handleClose}
                message="Note has been saved"
                action={action}
            />
            <Dialog
                open={openUrlPending}
                onClose={handleUrlPreviewClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Waiting to analyse results"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        This URL has not yet been analysed. Check back later
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleUrlPendingClose} autoFocus>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={screenshotFailedOpen}
                onClose={handleScreenshotfailedClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Sorry :("}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        We tried to make a screenshot, but it failed. Sometimes that happens.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleScreehotFailedClose} autoFocus>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
            <StyledDialog open={openUrlPreviewOpen} onClose={handleUrlPreviewClose}
                          maxWidth={"xl"} fullWidth={true}>
                <DialogTitle>URL Details </DialogTitle>
                <DialogContent dividers>
                    <Typography gutterBottom>
                        <Stack direction="row" spacing={2} alignItems={"center"}>
                            <strong><span>URL:</span></strong>
                            <Chip label={((currentUrlDetails.request.Parameters.Url.length > 200) ? currentUrlDetails.request.Parameters.Url.substring(0, 200) + "..." : currentUrlDetails.request.Parameters.Url)} />
                        </Stack>
                    </Typography>
                    <Typography gutterBottom>
                        <Stack direction="column" spacing={0}>
                            <Box><strong>Date Analysied:</strong> {moment(currentUrlDetails.request.DateGenerated).format("DD MMM YYYY HH:mm")}</Box>
                            <Typography sx={{pt:0}} variant="caption" display="block" gutterBottom>This date may predate the video if we have analysed this URL previously</Typography>
                        </Stack>
                    </Typography>
                    <Stack direction={"column"} spacing={1} sx={{mb:1}}>
                        <Typography gutterBottom>
                            <strong>Response Status:</strong> {currentUrlDetails.request.ResponseStatus}
                        </Typography>
                        {currentUrlDetails && currentUrlDetails.request.ResponseStatus === 0 && (
                            <Alert icon={<ReportProblemIcon fontSize="inherit" />} variant="outlined" severity="error">
                                This status indicates we could not reach the URL in question. Network errors, server issues etc can cause this. Not all information shown may be accurate.
                            </Alert>
                        )}

                        {currentUrlDetails && (currentUrlDetails.request.ResponseStatus === 300 || currentUrlDetails.request.ResponseStatus === 301)  && (
                            <Alert icon={<ReportProblemIcon fontSize="inherit" />} variant="outlined" severity="warning">
                                This URL sends visitors to another web page.
                            </Alert>
                        )}

                    </Stack>

                    <Typography gutterBottom>
                        <strong>Links On Page:</strong> {currentUrlLinks.length} found on page
                    </Typography>


                    <Typography gutterBottom>
                        <strong>Redirected?</strong>
                        <Box>
                            <Stack direction="row" spacing={2} alignItems={"center"}>
                                {redirects.length > 0 && (<span><CheckIcon  color="success" /> Final Url: {redirects[redirects.length-1]}</span>)}
                                {!redirects || redirects && redirects.length == 0 && (
                                    <Stack direction="row" spacing={2} alignItems={"center"}>
                                        <CancelIcon color="action" /> <span>No redirects where detected.</span>
                                    </Stack>
                                )}

                            </Stack>
                        </Box>
                    </Typography>


                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={tabUrlIndexvalue} onChange={handleUrlTabIndexChange} aria-label="" sx={{opacity:1}} >
                            <Tab label={CustomUrlTabAffLink()} {...a11yProps(0)} sx={{ opacity: 1 }}/>
                            <Tab label={CustomUrlTabRedirect()} {...a11yProps(1)} sx={{ opacity: 1 }}/>


                            <Tab label={CustomUrlTabAllLink()} {...a11yProps(2)} sx={{ opacity: 1 }}/>
                        </Tabs>
                    </Box>
                    <CustomTabPanel value={tabUrlIndexvalue} index={1}>
                        <Box  sx={{p:0}}>

                            <CustomPaginationActionsTable rows={currentUrlDetails.aff_urls_in_redirects} />
                        </Box>
                    </CustomTabPanel>
                    <CustomTabPanel value={tabUrlIndexvalue} index={0} sx={{backgroundColor:"#efefef"}}>
                        <Box sx={{p:0}}>
                            <Box sx={{p:2}}>
                                <Typography gutterBottom>
                                    <Stack direction="column" spacing={0}>
                                        <Box><strong>Brands linked on page:</strong> {currentUrlDetails.brands && currentUrlDetails.brands.filter(e=>e.dest_page && e.dest_page === true).map((row) => (
                                            <Chip label={row.organisation_brand.name} />
                                        ))}</Box>
                                    </Stack>
                                </Typography>
                            </Box>
                            <CustomPaginationActionsTable rows={currentUrlDetails.aff_urls_dest_page} />
                        </Box>
                    </CustomTabPanel>
                    <CustomTabPanel value={tabUrlIndexvalue} index={2}>
                        <Box  sx={{p:0}}>
                            <CustomPaginationActionsTable rows={currentUrlLinks} />
                            <Typography sx={{pt:2}} variant="caption" display="block" gutterBottom>Note: We do not analyse these links, they where found on {currentUrlDetails.request.Parameters.Url}</Typography>
                        </Box>
                    </CustomTabPanel>

                </DialogContent>
                <DialogActions>
                    <Button onClick={()=>{downloadScreenshot()}} variant="outlined" color="success">Download Screenshot</Button>
                    <Button onClick={()=>{setOpenUrlPreviewOpen(false)}} variant="outlined" color="error">Close</Button>
                </DialogActions>
            </StyledDialog>
            <Dialog
                open={showUrlNotAnalyzedDialog}
                onClose={() => setShowUrlNotAnalyzedDialog(false)}
                aria-labelledby="url-not-analyzed-dialog-title"
            >
                <DialogTitle id="url-not-analyzed-dialog-title">Information</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        This URL has not been analysed. We currently have no information about it.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setShowUrlNotAnalyzedDialog(false)} color="primary">
                        Dismiss
                    </Button>
                </DialogActions>
            </Dialog>

            <SimpleBackdrop  open={loading}/>
            {loadingUrlBackdrop()}
        </React.Fragment>
    )
    
}
